import './App.css';
import Location from './components/Location'

function App() {
  return (
    <div className="App">
      <Location/>
    </div>
  );
}

export default App;
